export default __webpack_public_path__ + "static/media/all.bad633c3.jpg";